import _ from "lodash";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  deleteBulkRequest,
} from "NetworkCall";

import {
  APP_API_KEY,
  INSTANCE_URL,
  itemCount,
  MAIN_URL,
  DEVELOPMENT_TYPE,
} from "Constants";
export const REWARD_DATA = "REWARD_DATA";

export function rewardSettingData(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=(eventid=${session.eventid})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // debugger;

        dispatch({
          type: REWARD_DATA,
          payload: { response: response.resource[0] },
        });

        callback({ error: 0, data: "Rewar Settings data fetched !" });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
}

// Insert And edit Challenges
export function updateRewardSettings(session, values, callback) {
  var eventid = session.eventid;
  values = { ...values, eventid };

  var response;
  var url, dataJson;

  var id = values.id;
  url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=id=${id}`;

  var removeKeyName = values.id;
  values = _.omit(values, [removeKeyName]);
  dataJson = { resource: values };
  return (dispatch) => {
    var successCallback = (data) => {
      callback({ error: 0, data: data });
    };

    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };

    patchRequest(
      url,
      dataJson,
      session,
      dispatch,
      successCallback,
      errorCallback
    );
  };
}
